import { Providers } from './providers';

/**
 * Root application component.
 * Renders the full provider tree including QueryClient, i18n, and Router.
 */
export function App() {
  return <Providers />;
}
